<template>
  <v-container fluid class="home-container">
    <v-row align="center" justify="center" class="fill-height">
      <v-col cols="12" md="8" lg="6">
        <v-card class="pa-6 text-center welcome-card" elevation="10">
          <v-avatar size="100" class="mb-4">
            <v-icon size="80" color="primary">mdi-tools</v-icon>
          </v-avatar>

          <h1 class="text-h3 font-weight-bold text-primary fade-in">
            ¡Bienvenido, {{ user.name }}!
          </h1>

          <p class="text-subtitle-1 text--secondary mt-2 fade-in">
            Nos alegra verte de nuevo
          </p>

          <v-divider class="my-4"></v-divider>

          <!--v-btn color="primary" class="mr-2 fade-in" elevation="2">
            <v-icon left>mdi-car</v-icon> Ver vehículos
          </v-btn>
          <v-btn color="secondary" class="fade-in" elevation="2">
            <v-icon left>mdi-tools</v-icon> Servicios
          </v-btn-->
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
  
  <script>
export default {
  data: () => ({
    username: "Usuario",
  }),
  computed: {
    user() {
      return this.$store.getters["auth/getUser"];
    },
  },
  methods: {},
};
</script>
 <style scoped>
/* Fondo elegante con un degradado sutil */
.home-container {
  background: linear-gradient(to bottom right, #2196f3, #e3f2fd);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Tarjeta principal con bordes redondeados y sombra */
.welcome-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.15);
}

/* Animación de entrada */
.fade-in {
  animation: fadeIn 1s ease-in-out;
}

/* Definición de la animación */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>